import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LoginViewLayoutComponent } from '../view/login-view-layout.component';

@Component({
    selector: 'login-form',
    templateUrl: './login-form.component.html',
    standalone: true,
    imports: [LoginViewLayoutComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginFormComponent {}
